import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '../../styles';
import { THUMBNAIL_WIDTH_LARGE, LINE_CLAMP } from './constants';
export const TileWrapper = styled(Grid) `
	float: left;
	margin: ${Magnetic.spacer04};
	border-width: 4px;
	border-style: ${Magnetic.baseBorderStyle};
	border-radius: ${Magnetic.baseBorderRadius};
	box-shadow: -1px 1px ${Magnetic.spacer04} ${Magnetic.colorNeutral30};
	border-color: ${(props) => props.selected ? Magnetic.colorBrand50 : Magnetic.colorWhite};
`;
export const TileView = styled(Grid) `
	position: relative;
	width: ${THUMBNAIL_WIDTH_LARGE};
	background-color: ${Magnetic.colorWhite};
	overflow: hidden;
`;
export const SmallTileWrapper = styled(Grid) `
	float: left;
	padding: ${(props) => (props.selected ? '0px' : '2px')};
	box-shadow: ${(props) => props.selected ? `-1px 1px 5px ${Magnetic.colorNeutral30}` : 'none'};
	border: ${(props) => props.selected ? `2px ${Magnetic.baseBorderStyle} ${Magnetic.colorBrand50}` : 'transparent'};
`;
export const StyledSmallTileDescriptionContainer = styled('div', {
    shouldForwardProp: prop => isPropValid(prop) && prop != 'width'
}) `
	font-size: ${Magnetic.fontSize12};
	color: ${Magnetic.colorBlack};
	text-align: center;
	margin-top: ${Magnetic.spacer04};
	max-width: ${(props) => props.width ? `${props.width}` : '100px'};
	word-break: break-word;
`;
export const SmallTileView = styled(Grid) `
	position: relative;
	height: ${(props) => props.height};
	width: ${(props) => props.width};
	background-color: transparent;
	overflow: hidden;
`;
export const FileNameContainer = styled('div') `
	display: flex;
	align-items: center;
	height: ${Magnetic.spacer40};
`;
export const FileName = styled('span') `
	color: ${Magnetic.colorNeutral60};
	font-size: ${Magnetic.baseFontSize};
	overflow: hidden;
	display: inline-block;
	padding-left: ${Magnetic.spacer04};
	white-space: nowrap;
	text-overflow: ellipsis;
	cursor: ${Magnetic.disabledCursor};
	outline: none;
`;
export const ShieldIcon = styled('span') `
	font-size: ${Magnetic.fontSize18};
	margin: 2px;
	color: ${(props) => props.isShared ? Magnetic.colorNeutral50 : Magnetic.colorBrand50};
`;
export const ThumbnailContainer = styled('div') `
	background-color: ${Magnetic.colorWhite};
	cursor: ${(props) => !props.selectMode ? Magnetic.disabledCursor : Magnetic.actionableCursor};
`;
export const ThumbnailContainerNamedTile = styled('div') `
	cursor: ${(props) => !props.selectMode ? Magnetic.disabledCursor : Magnetic.actionableCursor};
	border: ${(props) => `4px ${Magnetic.baseBorderStyle} ${props.selected ? Magnetic.colorBrand50 : 'transparent'}`};
`;
export const NamedTileView = styled(Grid) `
	position: relative;
	height: ${(props) => props.height};
	width: ${(props) => props.width};
	background-color: transparent;
	overflow: hidden;
`;
export const NamedTileWrapper = styled(Grid) `
	float: left;
	cursor: pointer;
`;
export const RectangleTagContainer = styled('span') `
	position: absolute;
	left: 0;
	bottom: -7px;
	margin: auto;
	z-index: 10;
	cursor: pointer;
`;
export const RectangleTagText = styled('text') `
	font-weight: ${Magnetic.fontWeightHeavy};
	font-size: ${Magnetic.fontSize10};
	fill: ${(props) => props.selected ? Magnetic.colorWhite : Magnetic.colorNeutral50};
	text-anchor: start;
`;
export const RectangleTagOuterContainer = styled('div', {
    shouldForwardProp: prop => prop !== 'hasMarginTop'
})(({ hasMarginTop }) => `
	margin: ${hasMarginTop ? Magnetic.spacer04 : 0} ${Magnetic.spacer04} 0;
	display: flex;
	justify-content: flex-start;
`);
export const RectangleTagInnerContainer = styled('div') `
	padding: 0 ${Magnetic.spacer04};
	line-height: ${Magnetic.spacer12};
	overflow: hidden;
	text-align: left;
	color: ${(props) => props.selected && !props.shouldNotSelectText ? Magnetic.colorWhite : Magnetic.colorNeutral50};
	background-color: ${(props) => props.selected && !props.shouldNotSelectText ? Magnetic.colorBrand50 : 'transparent'};
`;
export const RectangleTagNamedTileText = styled('span') `
	font-weight: ${Magnetic.fontWeightHeavy};
	font-size: ${Magnetic.fontSize10};
	font-family: 'Roboto Mono', 'Space Mono', monospace;
	white-space: pre-line;
	display: -webkit-box;
	-webkit-line-clamp: ${LINE_CLAMP};
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
`;
export const CheckMarkContainer = styled('div') `
	position: absolute;
	font-size: ${Magnetic.fontSize26};
	right: 5%;
	bottom: 5%;
	z-index: 10;
`;
export const CheckMarkPanel = styled('div') `
	background-color: ${Magnetic.colorWhite};
	border-radius: ${Magnetic.switchCircleBorderRadius};
	text-align: center;
	line-height: 26px;
	width: 31px;
	height: 31px;
`;
export const CheckMarkIcon = styled('span') `
	color: ${Magnetic.colorBrand50};
	vertical-align: middle;
	margin: 2px;
`;
export const TagText = styled('text') `
	font-weight: ${Magnetic.fontWeightHeavy};
	fill: ${Magnetic.colorWhite};
	text-anchor: middle;
`;
export const TagContainer = styled('span') `
	position: absolute;
	right: 0;
	top: 5px;
	margin: auto;
	z-index: 10;
`;
export const TagShape = styled('polygon') `
	fill: ${Magnetic.colorGreen05};
`;
export const TagShapeRect = styled('rect') `
	fill: ${(props) => props.selected ? Magnetic.colorBrand50 : Magnetic.colorNeutral10};
	opacity: ${(props) => (props.selected ? '1' : '0.75')};
`;
export const DescriptionContainer = styled(Grid) `
	width: 100%;
	border-top: 1px ${Magnetic.baseBorderStyle} ${Magnetic.colorNeutral5};
	height: ${Magnetic.spacer64};
	float: left;
`;
export const DescriptionTextArea = styled('textarea') `
	height: ${Magnetic.spacer64};
	border: none;
	width: 100%;
	color: ${Magnetic.colorNeutral60};
	resize: none;
	font-family: ${Magnetic.baseFontFamily};
	&:focus {
		outline: none;
	}
	overflow: auto;
	background-color: ${(props) => props.shouldAllowEditDescription ||
    (props.shouldAllowEditDescription === undefined && !props.isShared)
    ? Magnetic.colorWhite
    : Magnetic.colorNeutral5};
`;
export const StyledNamedTileView = styled('div') `
	position: relative;
	height: ${(props) => props.height};
	width: ${(props) => props.width};
	background-color: transparent;
	display: flex;
	flex-direction: ${(props) => (props.isHorizontal ? 'row' : 'column')};
	margin-bottom: ${(props) => (props.isHorizontal ? Magnetic.spacer04 : 0)};
`;
export const StyledTagsWrapper = styled('div') `
	display: ${(props) => props.isHorizontal ? 'flex' : 'block'};
	flex-direction: ${(props) => props.isHorizontal ? 'column' : 'row'};
	justify-content: center;
	align-items: flex-start;
`;
// twoLineEllipsis: enables 2-line ellipsis for vertical text tags
export const StyledTagNamedTileText = styled('div', {
    shouldForwardProp: (prop) => prop !== 'color' && prop !== 'isSecondaryTag' && prop !== 'twoLineEllipsis'
}) `
	font-weight: ${Magnetic.fontWeightHeavy};
	font-size: ${(props) => props.isSecondaryTag ? Magnetic.fontSize14 : Magnetic.fontSize10};
	font-family: ${Magnetic.baseFontFamily};
	color: ${(props) => props.color ? props.color : props.isSecondaryTag ? Magnetic.colorBlack : 'inherit'};
	${props => props.twoLineEllipsis
    ? `
				display: -webkit-box;
				-webkit-line-clamp: ${LINE_CLAMP};
				-webkit-box-orient: vertical;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: normal;
			`
    : `white-space: pre-wrap;`}
`;
export const StyledEditIcon = styled('span') `
	font-size: ${Magnetic.fontSize10};
	margin-left: ${Magnetic.spacer04};
	vertical-align: middle;
`;
export const StyledThumbnailContainerNamedTile = styled('div') `
	cursor: ${(props) => !props.selectMode ? Magnetic.disabledCursor : Magnetic.actionableCursor};
	border: ${(props) => `3px ${Magnetic.baseBorderStyle} ${props.warningIconSelected
    ? Magnetic.annotationAlertBorderColor
    : props.selected
        ? Magnetic.colorBrand50
        : 'transparent'}`};
`;
export const StyledTagIcon = styled('span') `
	display: inline-flex;
	align-items: center;
	color: ${(props) => props.iconColor || 'inherit'};
	font-size: ${Magnetic.fontSize10};
`;
export const StyledTagText = styled('span', {
    shouldForwardProp: prop => prop !== 'hasIcon'
}) `
	font-size: ${Magnetic.fontSize12};
	font-weight: ${(props) => props.hasIcon ? Magnetic.fontWeightNormal : Magnetic.fontWeightHeavy};
	color: inherit;
	padding-left: ${(props) => (props.hasIcon ? Magnetic.spacer04 : 0)};
	white-space: normal;
	line-height: normal;
`;
export const StyledTagLine = styled('span') `
	display: flex;
	align-items: center;
	width: 100%;
`;
//# sourceMappingURL=style.js.map